/*
 * A new side's objectives (v31.15, the state's `objectives`): the chain
 * from ore to an army, then the storm, each done or not as the world is
 * now. The panel's collapsed and finished states are kept per player on
 * this machine.
 */

import { createSignal } from "solid-js";

export interface Objective {
  id: string;
  text: string;
  done: boolean;
}

const [objectives, setList] = createSignal<Objective[]>([]);
export { objectives };

let last = "";
export function setObjectives(state: Record<string, unknown>): void {
  const list = Array.isArray(state.objectives) ? (state.objectives as Objective[]) : [];
  const key = JSON.stringify(list);
  if (key === last) return;
  last = key;
  setList(list);
}

/** Who the panel's remembered for ("<world>.<side>"). */
const [player, setPlayerKey] = createSignal("");
export { player as objectivesPlayer };
export const setObjectivesPlayer = (p: string) => setPlayerKey(p);

const STORE = "ferro.objectives";
type Kept = Record<string, { collapsed?: boolean; finished?: boolean }>;
function kept(): Kept {
  try {
    return JSON.parse(localStorage.getItem(STORE) ?? "{}") as Kept;
  } catch {
    return {};
  }
}
const [memory, setMemory] = createSignal<Kept>(kept());
export const objectivesKept = () => memory()[player()] ?? {};
export function keepObjectives(change: { collapsed?: boolean; finished?: boolean }): void {
  const all = { ...kept() };
  all[player()] = { ...all[player()], ...change };
  try {
    localStorage.setItem(STORE, JSON.stringify(all));
  } catch {
    // This session only.
  }
  setMemory(all);
}

/** What a click on the current objective does (the game sets it): opens
 *  the build it asks for, where there is one. */
let act: (id: string) => void = () => {};
export function setObjectiveAction(f: (id: string) => void): void {
  act = f;
}
export const runObjective = (id: string) => act(id);
